import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, LogIn } from "lucide-react";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("¡Bienvenido de nuevo!");
            const dest = loc.state?.from || "/dashboard";
            nav(dest);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto px-4 py-16" data-testid="login-page">
            <div className="brut-card p-8 grain">
                <div className="text-xs uppercase tracking-[0.3em] font-bold opacity-60 mb-1">Bienvenido</div>
                <h1 className="font-display font-black text-4xl uppercase mb-6">Ingresa</h1>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label htmlFor="email" className="brut-label">Email</label>
                        <input
                            id="email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="brut-input"
                            placeholder="tu@email.com"
                            data-testid="login-email"
                        />
                    </div>
                    <div>
                        <label htmlFor="password" className="brut-label">Contraseña</label>
                        <input
                            id="password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="brut-input"
                            placeholder="••••••••"
                            data-testid="login-password"
                        />
                    </div>
                    <button type="submit" disabled={loading} className="brut-btn brut-btn-primary w-full" data-testid="login-submit">
                        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" strokeWidth={3} />}
                        Ingresar
                    </button>
                </form>
                <p className="text-center text-sm mt-6">
                    ¿Aún no tienes cuenta? <Link to="/register" className="underline text-coral font-bold">Regístrate</Link>
                </p>
            </div>
        </div>
    );
}
